import { DispatchLoading, DispatchType, ResponseValid } from 'domain/utils/ReactUtils';
import { AppThunk } from 'base/src/utils/reducerUtil';
import { ExtratoRequest } from 'carteira/src/types/extrato/extratoRequest';
import { EXTRATO_RANGE } from 'domain/types/_carteira/extrato/extrato';
import { StateType } from 'domain/types/base/base';
import { ExtratoCampanhaService } from '../../../services/extrato/extratoCampanhaService';

const _ExtratoCampanhaService = new ExtratoCampanhaService();

export function GetExtratoCampanha(request: ExtratoRequest, carteiraId: number, callback: () => void): AppThunk {
  return async function thunk(dispatch) {
    dispatch(DispatchLoading(EXTRATO_RANGE, DispatchType.LOADING, 'Carregando', StateType.Master));

    const asyncResponse = await _ExtratoCampanhaService.GetExtrato(request, carteiraId);

    if (ResponseValid(asyncResponse, false, dispatch)) {
      dispatch({
        payload: asyncResponse,
        type: EXTRATO_RANGE,
      });

      callback();

      dispatch(DispatchLoading(EXTRATO_RANGE, DispatchType.SUCCESS));
    }
  };
}
